import React, { Component } from 'react'
import '../styles/Footer.css'
import { FaFacebook, FaInstagram } from 'react-icons/fa'
// import { Link } from '@reach/router'

export class Footer extends Component {
    render() {
        return (
            <div>
                <div className="footer-bottom">
                    <div>
                        &copy; 2022 <em>Wazito</em> Fitness Gym | All rights reserved        Email:wazitofitnessnrb@gmail.com
                    </div>
                    <div className="footer-icons">
                        <p className="follow-footer">Follow</p>
                        <p><a href="https://www.facebook.com/wazitofitnessgym/" target='_blank' rel='noreferrer'> <FaFacebook /> </a> </p>
                        <p><a href="https://www.instagram.com/tv/Cb-nbV3jWCc/?utm_medium=share_sheet" target='_blank' rel='noreferrer'><FaInstagram /></a></p>
                        {/* <p><a href="https://www.facebook.com/wazitofitnessgym/" target='_blank'><FaTwitter /></a></p> */}
                    </div>
                </div>
            </div>
        )
    }
}

export default Footer
